module.exports = __webpack_public_path__ + "static/media/mental-health.ba43d28f.jpg";